function trimOrigin(value) {
  if (value == null) return "";
  return String(value).trim().replace(/\/+$/, "");
}

function env(key, fallback) {
  const value = process.env[key];
  return value != null && String(value).trim() !== "" ? String(value).trim() : fallback;
}

/**
 * Runtime config — every value comes from classnora-ui/.env (REACT_APP_*).
 * Do not hardcode URLs or emails elsewhere; import from here or @/lib/api.
 */
export const SITE_URL = trimOrigin(env("REACT_APP_SITE_URL", "https://classnora.com"));

export const SITE_NAME = env("REACT_APP_SITE_NAME", "ClassNora");

export const SUPPORT_EMAIL = env("REACT_APP_SUPPORT_EMAIL", "support@classnora.com");

export const API_ORIGIN = trimOrigin(
  env("REACT_APP_API_URL", env("REACT_APP_BACKEND_URL", "https://api.classnora.com")),
);

export const DASHBOARD_URL = trimOrigin(
  env("REACT_APP_DASHBOARD_URL", "https://app.classnora.io"),
);

export const DAYCARE_PORTAL_URL = trimOrigin(
  env("REACT_APP_DAYCARE_PORTAL_URL", "https://daycare.classnora.com"),
);

export const PRESCHOOL_PORTAL_URL = trimOrigin(
  env("REACT_APP_PRESCHOOL_PORTAL_URL", "https://preschool.classnora.com"),
);

export const SCHOOL_PORTAL_URL = trimOrigin(
  env("REACT_APP_SCHOOL_PORTAL_URL", "https://school.classnora.com"),
);

export const ACADEMY_PORTAL_URL = trimOrigin(
  env("REACT_APP_ACADEMY_PORTAL_URL", "https://academy.classnora.com"),
);

export const COLLAGE_PORTAL_URL = trimOrigin(
  env("REACT_APP_COLLAGE_PORTAL_URL", "https://collage.classnora.com"),
);

/** CRA dev-server proxy target when the client uses same-origin `/api`. */
export const API_PROXY_TARGET = trimOrigin(
  env("REACT_APP_API_PROXY_TARGET", "http://127.0.0.1:3003"),
);

/** Build an absolute URL on the marketing site. */
export function siteUrl(path = "") {
  if (!path || path === "/") return SITE_URL;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
}

/** Build a schema.org @id fragment URL (e.g. …/#website). */
export function siteAnchor(fragment) {
  const id = String(fragment).replace(/^#/, "");
  return `${SITE_URL}/#${id}`;
}

export function getSiteHostname() {
  try {
    return new URL(SITE_URL).hostname;
  } catch {
    return new URL(SITE_URL || "https://classnora.com").hostname;
  }
}

export function getDashboardHost() {
  try {
    return new URL(DASHBOARD_URL).host;
  } catch {
    return new URL(DASHBOARD_URL || "https://app.classnora.io").host;
  }
}

/**
 * Base URL for marketing-site REST calls (e.g. …/public/contactus).
 * Uses REACT_APP_API_URL from `.env` → `{origin}/api`.
 */
export function getApiBase() {
  const origin = trimOrigin(
    process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL || API_ORIGIN,
  );
  return origin.endsWith("/api") ? origin : `${origin}/api`;
}
